import React from 'react';

export const whatsappIcon = () => {
  return (
    <img 
      src="/static/images/whatsapp.png" 
      alt="WhatsApp"
      className='w-12 h-12'
      style={{ display: 'inline-block' }}
    />
  );
}; 